import '../templates/components/wishlist-button/wishlist-button.js';
import '../templates/components/brand-follow-button/brand-follow-button.js';
import { wishlistService } from './service/wishlist-service.js';
import { wishlistHeaderCountService } from './service/wishlist-header-count-service.js';
import { brandService } from './service/brand-service.js';

wishlistHeaderCountService.init();
wishlistService.init();
brandService.init();
